import { render, staticRenderFns } from "./PresentOfSmartTk.vue?vue&type=template&id=40c5e2ec&scoped=true"
import script from "./PresentOfSmartTk.vue?vue&type=script&lang=js"
export * from "./PresentOfSmartTk.vue?vue&type=script&lang=js"
import style0 from "./PresentOfSmartTk.vue?vue&type=style&index=0&id=40c5e2ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5e2ec",
  null
  
)

export default component.exports